import React from "react";
import DocumentMeta from "react-document-meta";
import LeftTab from "../Common/LeftTab";
import { ToastContainer } from "react-toastify";
import LoginHeader from "../Common/LoginHeader";
import Personal from "./Personal";
import Aadhaar from "./Aadhaar";
import Pancard from "./Pancard";
import NationId from "./NationId";
import Passport from "./Passport";
import Bank from "./Bank";
import Nominee from "./Nominee";
import Upi from "./Upi";
import Face from "./Face";
import { useKycTrackQuery } from "../../redux/kycApi";
import ClipLoader from "react-spinners/ClipLoader";

const meta = {
  title: "KYC | Green Crypto X Exchange",
  description:
    "Green Crypto X Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Cyrpto Exchange In India Like Bitcoin And Dogecoin.",
  canonical: "https://Green Crypto XExchange.live/buy-sell-crypto-online",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

// Map of keys from API to React components
const componentMap = {
  bank_verification: Bank,
  upi_verification: Upi,
  nominee_verification: Nominee,
  aadhaar_verification: Aadhaar,
  pan_verification: Pancard,
  nation_verification: NationId,
  passport_verification: Passport,
  face_verification: Face,
};

const kycOrder = [
  "email_verification",
  "phone_verification",
  // "bank_verification",
  // "upi_verification",
  "nominee_verification",
  "aadhaar_verification",
  "pan_verification",
  "nation_verification",
  "passport_verification",
  "face_verification",
];

const progress = {
  email_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
  phone_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },

  // bank_verification: {
  //   pending: "pending",
  //   submitted: "submitted",
  //   approved: "complete",
  //   rejected: "rejected",
  // },
  // upi_verification: {
  //   pending: "pending",
  //   submitted: "submitted",
  //   approved: "complete",
  //   rejected: "rejected",
  // },
  nominee_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
  aadhaar_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
  pan_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
  nation_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
  passport_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
  face_verification: {
    pending: "pending",
    submitted: "submitted",
    approved: "complete",
    rejected: "rejected",
  },
};

const Index = () => {
  const {
    data: kycTrack,
    refetch: refetchTrack,
    isLoading: kycLoading,
  } = useKycTrackQuery();

  console.log(kycTrack, "kycTrack");

  const getKycClass = (section) => {
    const status = kycTrack?.progress?.[section]?.status?.toLowerCase();
    return progress?.[section]?.[status] || "";
  };

  return (
    <div>
      <div className="bghwhite">
        <LoginHeader id={"allow"} />
        <DocumentMeta {...meta}>
          <div className="kyc-main">
            <div className="bghwhite">
              <div className="new_inpage">
                <div className="container container2">
                  <LeftTab />
                  {kycLoading ? (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: "60vh" }}
                    >
                      <ClipLoader
                        size={50} // diameter
                        color="#888888" // gray color
                        cssOverride={{
                          // make border thicker
                          borderWidth: "6px",
                        }}
                      />{" "}
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-3 col-12">
                        {kycTrack?.isComplete === 1 && (
                          <div className="white_box heading-main">
                            <h5 className="position-relative">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              />{" "}
                              Verification Completed
                            </h5>
                          </div>
                        )}

                        <div className="white_box heading-main m-0">
                          {Object.entries(kycTrack?.progress || {}).map(
                            ([key, value]) => {
                              const formattedKey = key
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase());
                              // const isOptional = kycTrack?.country_code !== "+91" && [
                              //   "bank_verification",
                              //   "upi_verification",
                              //   "nominee_verification",
                              // ].includes(key);
                              return (
                                <h6
                                  key={key}
                                  className={`position-relative ${getKycClass(
                                    key
                                  )}`}
                                >
                                  {formattedKey}
                                  {/* {isOptional && "(Optional)"} */}
                                </h6>
                              );
                            }
                          )}
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div className="right_scrool">
                          <Personal
                            refetch={refetchTrack}
                            kycTrack={kycTrack}
                            mode={
                              kycTrack?.progress?.email_verification?.data
                                ? "email"
                                : "phone"
                            }
                          />
                          {console.log(
                            kycTrack?.progress?.phone_verification,
                            "hii"
                          )}
                          <Personal
                            refetch={refetchTrack}
                            kycTrack={kycTrack}
                            mode={"phone"}
                          />

                          {(() => {
                            let allowNext = true;

                            // Base filtering
                            let filteredKycOrder = kycOrder;

                            // If country code is +91, exclude only nation_verification
                            if (kycTrack?.country_code === "+91") {
                              filteredKycOrder = kycOrder.filter(
                                (key) =>
                                  key !== "nation_verification" &&
                                  key !== "passport_verification"
                              );
                            } else {
                              // For all other countries, exclude upi, aadhar, pan
                              filteredKycOrder = kycOrder.filter(
                                (key) =>
                                  key !== "upi_verification" &&
                                  key !== "aadhaar_verification" &&
                                  key !== "pan_verification"
                              );
                            }

                            return filteredKycOrder.map((sectionKey, index) => {
                              const status =
                                kycTrack?.progress?.[sectionKey]?.status;
                              const Component = componentMap[sectionKey];
                              if (!Component) return null;
                              if (
                                ["approved", "rejected", "submitted"].includes(
                                  status
                                )
                              ) {
                                return (
                                  <Component
                                    key={sectionKey}
                                    refetch={refetchTrack}
                                    kycTrack={kycTrack}
                                    userinfo={{ done: "" }}
                                  />
                                );
                              }

                              if (status === "pending" && allowNext) {
                                const prevKey = filteredKycOrder[index - 1];
                                const prevStatus =
                                  kycTrack?.progress?.[prevKey]?.status;

                                if (
                                  index === 0 ||
                                  ["approved", "submitted"].includes(prevStatus)
                                ) {
                                  allowNext = false;
                                  return (
                                    <Component
                                      key={sectionKey}
                                      refetch={refetchTrack}
                                      kycTrack={kycTrack}
                                    />
                                  );
                                }

                                return null;
                              }

                              return null;
                            });
                          })()}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </DocumentMeta>
      </div>
    </div>
  );
};

export default Index;
